import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconMessage } from '@assets/svg/message.svg';
import { ReactComponent as IconPeople } from '@assets/svg/people.svg';
import { CommonCard } from '@organisms';

interface CardListProps {
  totalContacts: number;
  totalMessages: number;
  activeInactive: ActiveInactive;
}

const formatPct = (numerator: number, denominator: number) => {
  if (denominator <= 0) return '';
  return `${Math.round((numerator / denominator) * 100)}%`;
};

const CardList: React.FC<CardListProps> = ({
  totalContacts,
  totalMessages,
  activeInactive
}: CardListProps) => {
  const totalActive = activeInactive?.active ?? 0;
  const totalInactive = activeInactive?.inactive ?? 0;
  const totalLicenses = totalActive + totalInactive;

  return (
    <Stack spacing={2}>
      <CommonCard
        title="Total Contacts Engaged"
        count={totalContacts}
        icon={<IconPeople />}
        accent="info"
      />
      <CommonCard
        title="Total Messages"
        count={totalMessages}
        icon={<IconMessage />}
        accent="secondary"
      />
      <CommonCard title="Total Licences" count={totalLicenses} icon={<IconTeam />} accent="highlight">
        <Stack direction="row" spacing={3}>
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#16a34a', lineHeight: 1.2 }}>
              {totalActive}
            </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 500, color: 'rgba(15, 23, 42, 0.55)' }}>
              Active {formatPct(totalActive, totalLicenses) && `· ${formatPct(totalActive, totalLicenses)}`}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#d97706', lineHeight: 1.2 }}>
              {totalInactive}
            </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 500, color: 'rgba(15, 23, 42, 0.55)' }}>
              Inactive {formatPct(totalInactive, totalLicenses) && `· ${formatPct(totalInactive, totalLicenses)}`}
            </Typography>
          </Box>
        </Stack>
      </CommonCard>
    </Stack>
  );
};

export default CardList;
